'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _reactBootstrap = require('react-bootstrap');

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _reactRouter = require('react-router');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Register = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    registerError: state.auth.registerError,
    registerSuccess: state.auth.registerSuccess,
    registeringIn: state.auth.registeringIn
  };
}, authActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Register);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputs: {
        email: '',
        name: '',
        phone: '',
        gender: '',
        password: '',
        confirm_password: '',
        token: ''
      },
      birthday: '',
      nameValidate: true,
      emailValidate: true,
      passwordValidate: true,
      cpValidate: true,
      notRobot: true,
      showModalSuccess: false,
      showModalError: false,
      errorMsg: ''
    }, _this.onChangeEmail = function (event) {
      var emailValidate = false;
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value) || event.target.value === '') {
        emailValidate = true;
      }
      var inputs = _this.state.inputs;
      inputs.email = event.target.value;
      _this.setState({
        inputs: inputs,
        emailValidate: emailValidate
      });
    }, _this.handleOpenModalSuccess = function () {
      _this.setState({
        showModalSuccess: !_this.state.showModalSuccess
      });
    }, _this.handleOpenModalError = function () {
      _this.setState({
        showModalError: !_this.state.showModalError
      });
    }, _this.loginFacebook = function () {
      window.FB.login();
    }, _this.responseGoogleSuccess = function (response) {
      _this.props.loginGoogle(response.accessToken);
    }, _this.responseGoogleFailure = function (response) {
      if (response.error === 'access_denied') {
        _this.setState({ errorMsg: 'Vui lòng cấp quyền cho app' });
        _this.handleOpenModalError();
      } else if (response.error === 'immediate_failed') {
        _this.setState({ errorMsg: 'Đã xảy ra lỗi. Vui lòng thử lại' });
        _this.handleOpenModalError();
      }
    }, _this.responsePhone = function (response) {
      _this.props.loginPhone(response);
    }, _this.onChangePassword = function (event) {
      var passwordValidate = false;
      var cpValidate = true;
      if (event.target.value.length >= 8 || event.target.value === '') {
        passwordValidate = true;
      }
      if (_this.confirm_password.value !== '' && _this.confirm_password.value !== event.target.value) {
        cpValidate = false;
      }
      var inputs = _this.state.inputs;
      inputs.password = event.target.value;
      _this.setState({
        inputs: inputs,
        passwordValidate: passwordValidate,
        cpValidate: cpValidate
      });
    }, _this.onChangeCP = function (event) {
      var cpValidate = false;
      if (event.target.value.length >= 8 && _this.password.value === event.target.value || event.target.value === '') {
        cpValidate = true;
      }
      var inputs = _this.state.inputs;
      inputs.confirm_password = event.target.value;
      _this.setState({
        inputs: inputs,
        cpValidate: cpValidate
      });
    }, _this.onChangeDOB = function (value) {
      _this.setState({
        birthday: value
      });
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      var inputs = _this.state.inputs;
      var emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(_this.email.value);
      var passwordValidate = _this.password.value.length >= 8;
      var nameValidate = _this.name.value ? true : false;
      var cpValidate = _this.password.value === _this.confirm_password.value;
      var notRobot = inputs.token ? true : false;
      var birthdayDate = _this.state.birthday;
      if (emailValidate && passwordValidate && cpValidate && notRobot && nameValidate) {
        inputs.phone = _this.phone.value;
        inputs.name = _this.name.value;
        inputs.dob = birthdayDate;
        inputs.gender = _this.gender.value;
        inputs.email = _this.email.value;
        _this.props.register(inputs);
      } else {
        _this.setState({
          nameValidate: nameValidate,
          emailValidate: emailValidate,
          passwordValidate: passwordValidate,
          cpValidate: cpValidate,
          notRobot: notRobot
        });
      }
    }, _this.confirmSuccess = function () {
      _reactRouter.browserHistory.push('/');
      _this.props.resetRegisterStatus();
    }, _this.changeCaptcha = function (value) {
      var inputs = _this.state.inputs;
      inputs.token = value;
      _this.setState(inputs);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Register, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.registerSuccess && nextProps.registerSuccess === true) {
        this.handleOpenModalSuccess.call(this);
      }
      if (!this.props.registerError && nextProps.registerError) {
        this.handleOpenModalError.call(this);
      }
    }
    // componentWillUnmount() {
    //   this.props.resetRegisterStatus();
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Register.scss');
      var _props = this.props,
          registerError = _props.registerError,
          registeringIn = _props.registeringIn;
      var _state = this.state,
          nameValidate = _state.nameValidate,
          emailValidate = _state.emailValidate,
          passwordValidate = _state.passwordValidate,
          cpValidate = _state.cpValidate,
          inputs = _state.inputs,
          notRobot = _state.notRobot,
          showModalError = _state.showModalError,
          showModalSuccess = _state.showModalSuccess,
          birthday = _state.birthday,
          errorMsg = _state.errorMsg;

      return _react2.default.createElement(
        'div',
        { className: styles.registerPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Register' }),
        registeringIn && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(
          'div',
          { className: styles.loginContent },
          _react2.default.createElement(
            'div',
            { className: styles.leftContent },
            _react2.default.createElement(
              'div',
              { className: styles.headerLogin },
              '\u0110\u0103ng K\xFD T\xE0i Kho\u1EA3n'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.social },
              _react2.default.createElement(
                'div',
                {
                  className: styles.facebook,
                  onClick: function onClick() {
                    return _this2.loginFacebook();
                  }
                },
                _react2.default.createElement('i', {
                  className: 'fa fa-facebook ' + styles.icon,
                  'aria-hidden': 'true'
                }),
                _react2.default.createElement(
                  'span',
                  { className: styles.socialLabel },
                  'Facebook'
                )
              ),
              _react2.default.createElement(
                _reactGoogleLogin2.default,
                {
                  className: styles.google,
                  clientId: '21833284502-f02ii6689231i26sfpduhpduim8a30tj.apps.googleusercontent.com',
                  onSuccess: this.responseGoogleSuccess,
                  onFailure: this.responseGoogleFailure
                },
                _react2.default.createElement('i', {
                  className: 'fa fa-google ' + styles.icon,
                  'aria-hidden': 'true'
                }),
                'Google'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _FirebaseAuth2.default,
                { desktopMode: true, onResponse: this.responsePhone },
                function (p) {
                  return _react2.default.createElement(
                    'button',
                    (0, _extends3.default)({}, p, { className: styles.phone }),
                    _react2.default.createElement('i', {
                      className: 'fa fa-phone ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    'Login with Phone Number'
                  );
                }
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.or },
              'ho\u1EB7c'
            ),
            _react2.default.createElement(
              'form',
              { onSubmit: this.handleSubmit, className: styles.loginForm },
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  { className: styles.groupInput },
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    { className: styles.inputIcon },
                    _react2.default.createElement('i', {
                      className: 'fa fa-user-o ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: styles.required },
                      '*'
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    inputRef: function inputRef(ref) {
                      return _this2.name = ref;
                    },
                    className: styles.inputLogin,
                    type: 'text',
                    placeholder: 'T\xEAn \u0111\u0103ng k\xFD'
                  })
                ),
                nameValidate === false && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  'T\xEAn kh\xF4ng th\u1EC3 tr\u1ED1ng!'
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  { className: styles.groupInput },
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    { className: styles.inputIcon },
                    _react2.default.createElement('i', {
                      className: 'fa fa-envelope-o ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: styles.required },
                      '*'
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    inputRef: function inputRef(ref) {
                      return _this2.email = ref;
                    },
                    onChange: this.onChangeEmail,
                    className: styles.inputLogin,
                    type: 'text',
                    placeholder: 'Email',
                    value: inputs.email
                  })
                ),
                emailValidate === false && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  'Email kh\xF4ng h\u1EE3p l\u1EC7!'
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  { className: styles.groupInput },
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    { className: styles.inputIcon },
                    _react2.default.createElement('i', {
                      className: 'fa fa-lock ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: styles.required },
                      '*'
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    inputRef: function inputRef(ref) {
                      return _this2.password = ref;
                    },
                    className: styles.inputLogin,
                    minLength: '8',
                    type: 'password',
                    placeholder: 'M\u1EADt kh\u1EA9u',
                    onChange: this.onChangePassword,
                    value: inputs.password
                  })
                ),
                passwordValidate === false && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  'M\u1EADt kh\u1EA9u ph\u1EA3i tr\xEAn 8 k\xFD t\u1EF1!'
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  { className: styles.groupInput },
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    { className: styles.inputIcon },
                    _react2.default.createElement('i', {
                      className: 'fa fa-lock ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: styles.required },
                      '*'
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    inputRef: function inputRef(ref) {
                      return _this2.confirm_password = ref;
                    },
                    className: styles.inputLogin,
                    minLength: '8',
                    type: 'password',
                    placeholder: 'X\xE1c nh\u1EADn m\u1EADt kh\u1EA9u',
                    onChange: this.onChangeCP,
                    value: inputs.confirm_password
                  })
                ),
                cpValidate === false && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  'M\u1EADt kh\u1EA9u kh\xF4ng tr\u1EEBng kh\u1EDBp!'
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup + ' ' + styles.b_g },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  {
                    className: styles.groupInput + ' ' + styles.birthday
                  },
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    { className: styles.inputIcon },
                    _react2.default.createElement('i', {
                      className: 'fa fa-calendar ' + styles.icon,
                      'aria-hidden': 'true'
                    })
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    value: birthday,
                    className: styles.inputLogin,
                    onChange: function onChange(event) {
                      return _this2.onChangeDOB(event.target.value);
                    },
                    type: 'date',
                    placeholder: 'Ng\xE0y sinh'
                  })
                ),
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  { className: styles.groupInput + ' ' + styles.gender },
                  _react2.default.createElement(
                    _reactBootstrap.FormControl,
                    {
                      inputRef: function inputRef(ref) {
                        return _this2.gender = ref;
                      },
                      className: styles.inputLogin,
                      componentClass: 'select'
                    },
                    _react2.default.createElement(
                      'option',
                      { value: 'female' },
                      'N\u1EEF'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'male' },
                      'Nam'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'other' },
                      'Kh\xE1c'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  { className: styles.groupInput },
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    { className: styles.inputIcon },
                    _react2.default.createElement('i', {
                      className: 'fa fa-phone ' + styles.icon,
                      'aria-hidden': 'true'
                    })
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    inputRef: function inputRef(ref) {
                      return _this2.phone = ref;
                    },
                    className: styles.inputLogin,
                    type: 'text',
                    placeholder: '\u0110i\u1EC7n tho\u1EA1i'
                  })
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup + ' ' + styles.captcha },
                _react2.default.createElement(_reactGoogleRecaptcha2.default, {
                  size: 'normal',
                  ref: 'recaptcha',
                  sitekey: '6LfAv0AUAAAAAKj4iFf0rXSPl1-6bcF1AP4P7GZd',
                  onChange: this.changeCaptcha
                }),
                notRobot === false && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  'Vui l\xF2ng ch\u1ECDn: "I\'m not robot"'
                )
              ),
              _react2.default.createElement(
                'button',
                { className: styles.buttonLogin, type: 'submit' },
                '\u0110\u0102NG K\xDD'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.register },
              _react2.default.createElement(
                'div',
                null,
                '\u0110\xE3 c\xF3 t\xE0i kho\u1EA3n ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Lookme'
                ),
                '?',
                ' ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/dang-nhap' },
                  '\u0110\u0103ng nh\u1EADp ngay'
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.rightContent })
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalSuccess,
            hide: this.handleOpenModalSuccess,
            className: 'modal-alert-login'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleOpenModalSuccess
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'B\u1EA1n \u0111\xE3 \u0111\u0103ng k\xFD th\xE0nh c\xF4ng. Vui l\xF2ng ki\u1EC3m tra email \u0111\u1EC3 c\xF3 th\u1EC3 k\xEDch ho\u1EA1t t\xE0i kho\u1EA3n.'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: function onClick() {
                    return _this2.confirmSuccess();
                  }
                },
                'X\xE1c nh\u1EADn'
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalError,
            hide: this.handleOpenModalError,
            className: 'modal-alert-login'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleOpenModalError
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              registerError && registerError.msg || errorMsg
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: function onClick() {
                    return _this2.handleOpenModalError();
                  }
                },
                'X\xE1c nh\u1EADn'
              )
            )
          )
        )
      );
    }
  }]);
  return Register;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  registerError: _react.PropTypes.object,
  register: _react.PropTypes.func,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func,
  registerSuccess: _react.PropTypes.bool,
  resetRegisterStatus: _react.PropTypes.func,
  registeringIn: _react.PropTypes.bool,
  loginGoogle: _react.PropTypes.func,
  loginPhone: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = Register;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/Register.js
// module id = 1692
// module chunks = 0